var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.showDesktop)?_c('DesktopHeader'):_vm._e(),(_vm.showWidescreen)?_c('WidescreenHeader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }